/**************************************************************************************************/
/*   File: /src/app/shared/enums/geo.file.type.enum.ts                                            */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { GeoFileType } from '../models/geo.file.type';
import { SpatialDataTypeEnum } from './spatial.data.type.enum';

/**
 * The geo file type enum
 */
export namespace GeoFileTypeEnum {
    /**
     * The created state
     */
    const DWG: GeoFileType = {
        id: SpatialDataTypeEnum.DWG,
        key: 'file_type_dwg'
    };
    /**
     * The validation state
     */
    const SHP: GeoFileType = {
        id: SpatialDataTypeEnum.SHAPE,
        key: 'file_type_shp'
    };
    /**
     * The not deliverable state
     */
    const DXF: GeoFileType = {
        id: SpatialDataTypeEnum.DXF,
        key: 'file_type_dxf'
    };

    /**
     * The types exported
     */
    export const TYPES: GeoFileType[] = [
        DWG,
        DXF,
        SHP
    ];
}